import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';

import {
  getCart,
  unloadCart,
  updateItemQuantity,
  removeItem,
  removeItems,
} from '../../actions/CartActions';
import CartItem from './CartItem';
import CartInvites from './CartInvites';
import SecuritySeal from '../common/SecuritySeal';
import CompactCurrency from '../product/PricingUtils';
import Loader from '../common/ui/Loader';
import { trackCartViewed } from '../../util/trackingHelper';
import featureFlags from '../../util/featureFlags';

class Cart extends Component {
  constructor(props) {
    super(props);

    this.updateCartItemQuantity = this.updateCartItemQuantity.bind(this);
    this.removeCartItem = this.removeCartItem.bind(this);
    this.removeCartItems = this.removeCartItems.bind(this);
  }

  componentDidMount() {
    const { onFetchCart } = this.props;
    onFetchCart().then(() => this.trackCartViewedEvent());
  }

  componentWillUnmount() {
    const { onUnloadCart } = this.props;
    onUnloadCart();
  }

  trackCartViewedEvent() {
    if (featureFlags.get('cartViewedEvent')) {
      const { registryId, cartId, items } = this.props;
      trackCartViewed(registryId, cartId, items);
    }
  }

  updateCartItemQuantity(id, quantity) {
    const { onUpdateCartItemQuantity } = this.props;
    return onUpdateCartItemQuantity(id, quantity);
  }

  removeCartItem(id) {
    const { onRemoveCartItem } = this.props;
    onRemoveCartItem(id);
  }

  removeCartItems(itemIds) {
    const { onRemoveCartItems } = this.props;
    onRemoveCartItems(itemIds);
  }

  render() {
    const { initialized, items, totals, isFreeShippingEligible, freeShipping } = this.props;

    const isEmpty = items.length === 0;
    const showShippingBanner = isEmpty || isFreeShippingEligible || freeShipping;

    return (
      <div className="zola-registry-styles">
        <div className="cart-header clearfix">
          <h3 className="pull-left">Your Cart</h3>
          {initialized && !isEmpty && (
            <ButtonV2 component="a" href="/cart/checkout" className="pull-right">
              Checkout Now
            </ButtonV2>
          )}
        </div>
        {initialized ? (
          <div>
            {showShippingBanner && (
              <div className="alert cart-free-shipping cart-free-shipping-not-met">
                <i className="zolaicon zolaicon-truck" />
                <p>Good to know: we offer free shipping everyday</p>
              </div>
            )}
            {/* empty cart */}
            {isEmpty && (
              <h4 className="text-center cart-empty-message">
                You have nothing in your cart. Get shopping!
              </h4>
            )}
            {/* cart with items */}
            {!isEmpty && (
              <div>
                <div className="row cart-items-header hidden-xs">
                  <div className="col-sm-6">Item</div>
                  <div className="col-sm-2">Unit Price</div>
                  <div className="col-sm-2">Quantity</div>
                  <div className="col-sm-2 text-right">Subtotal</div>
                </div>
                {items.map(item =>
                  item.isInvite ? (
                    <CartInvites key={item.id} item={item} removeItems={this.removeCartItems} />
                  ) : (
                    <CartItem
                      key={item.id}
                      item={item}
                      updateQuantity={this.updateCartItemQuantity}
                      remove={this.removeCartItem}
                    />
                  )
                )}
                <div className="cart-totals">
                  <div className="form-label">Subtotal:</div>{' '}
                  <strong className="text-primary">{CompactCurrency(totals.subtotal)}</strong>
                  <br />
                  {totals.amountSaved > 0 && (
                    <small className="text-secondary">
                      You&apos;re saving <strong>{CompactCurrency(totals.amountSaved)}</strong>
                    </small>
                  )}
                </div>
              </div>
            )}
            <div className="cart-footer clearfix">
              <div className="pull-left">
                <SecuritySeal />
              </div>
              {!isEmpty && (
                <ButtonV2 component="a" href="/cart/checkout" className="pull-right">
                  Checkout Now
                </ButtonV2>
              )}
            </div>
          </div>
        ) : (
          <Loader delay />
        )}
      </div>
    );
  }
}

Cart.propTypes = {
  initialized: PropTypes.bool,
  isFreeShippingEligible: PropTypes.bool,
  freeShipping: PropTypes.shape({}), // temporary
  items: PropTypes.arrayOf(PropTypes.shape({})),
  cartId: PropTypes.string,
  registryId: PropTypes.string,
  totals: PropTypes.shape({
    subtotal: PropTypes.number,
    amount_saved: PropTypes.number,
  }),
  onFetchCart: PropTypes.func.isRequired,
  onRemoveCartItem: PropTypes.func.isRequired,
  onRemoveCartItems: PropTypes.func.isRequired,
  onUpdateCartItemQuantity: PropTypes.func.isRequired,
  onUnloadCart: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  ...state.cart,
});

const mapDispatchToProps = dispatch => ({
  onFetchCart: () => dispatch(getCart()),
  onRemoveCartItem: id => dispatch(removeItem(id)),
  onRemoveCartItems: ids => dispatch(removeItems(ids)),
  onUpdateCartItemQuantity: (id, quantity) => dispatch(updateItemQuantity(id, quantity)),
  onUnloadCart: () => dispatch(unloadCart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cart);



// WEBPACK FOOTER //
// ./src/components/cart/Cart.jsx